import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { SANDBOX_CONTACT_FORM_URL } from '@backrs_ui/grow-ui/src/settings';

import { Button, SxProps } from '@mui/material';

const STRINGS = appStrings.modules.sandboxContactCta;

export const SandboxContactButton = () => (
  <Button
    id="sandbox-contact-button"
    hierarchy="Secondary gray"
    size="md"
    sx={noWrapSx}
    onClick={() => window.open(SANDBOX_CONTACT_FORM_URL, '_blank')}
  >
    {STRINGS.headerButton}
  </Button>
);

const noWrapSx: SxProps = { whiteSpace: 'nowrap' };
